import React, { useCallback } from "react";
import { ModalProps } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import "./SignOutModal.scss";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";
import FilledButton, {
  ButtonSizes,
} from "../../dashboard-page/FilledButton/FilledButton";
import useAuth from "../../../hooks/useAuth";
import { ROUTES } from "../../../utils/constants";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";

interface SignOutModalProps extends Pick<ModalProps, "show"> {
  redirectUrl?: string;
  onHide: () => void;
}
function SignOutModal({
  show,
  onHide,
  redirectUrl = ROUTES.GAMES.ROOT,
  ...restProps
}: SignOutModalProps) {
  const navigate = useNavigate();
  const { logOut } = useAuth();

  const handleSignOut = useCallback(() => {
    logOut();
    navigate(redirectUrl);
  }, [logOut, navigate, redirectUrl]);

  return (
    <BottomDrawer onClose={onHide} isOpen={!!show} {...restProps}>
      <div className="sign-out-modal">
        <div>
          <h2 className="heading">Sign out</h2>
          <p className="content">Are you sure you want to sign out?</p>
          <FilledButton
            fullwidth
            size={ButtonSizes.MD}
            className="mb-1"
            onClick={onHide}
          >
            No, Go Back
          </FilledButton>
          <GhostButton className="cancel-btn" onClick={handleSignOut}>
            Sign Out
          </GhostButton>
        </div>
      </div>
    </BottomDrawer>
  );
}

export default SignOutModal;
